import styled from 'styled-components';

const AbsolutePositioned = styled.div`
  ${({ top = '0px', left = '0px', bottom = 'unset', right = 'unset' }) => `
    position: absolute;
    top: ${top};
    left: ${left};
    bottom: ${bottom};
    right: ${right};
  `};
`;

const AbsoluteCenter = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const BackgroundContainer = AbsolutePositioned.extend`
  height: 100%;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
`;

export { AbsolutePositioned, BackgroundContainer, AbsoluteCenter };



// WEBPACK FOOTER //
// ./src/components/Layout/AbsolutePositioned.jsx